// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------
import { __decorate } from 'tslib';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { sharedStyles } from '../../styles';
import { ShuiLitElement } from '../../utils/event-decorator.js';
let SHBreadcrumbs = class SHBreadcrumbs extends ShuiLitElement {
  constructor() {
    super(...arguments);
    /**Role for the breadcrumb navigation container */
    this.role = 'navigation';
  }
  static get styles() {
    return [
      sharedStyles,
      css`
        :host {
          float: left;
          display: block;
          overflow: hidden;
        }
        .list-container {
          padding: 0;
          margin: 0;
        }
      `,
    ];
  }
  render() {
    return html`
      <ul class="list-container">
        <slot @slotchange="${this._handleSlotChange}"></slot>
      </ul>
    `;
  }
  _handleSlotChange() {
    const breadcrumbItems = this.querySelectorAll('sh-breadcrumb-item');
    for (let i = 0; i < breadcrumbItems.length; i++) {
      breadcrumbItems[i].active = true;
      if (breadcrumbItems[i - 1]) {
        breadcrumbItems[i - 1].active = false;
      }
    }
  }
};
__decorate([property({ type: String, reflect: true })], SHBreadcrumbs.prototype, 'role', void 0);
SHBreadcrumbs = __decorate([customElement('sh-breadcrumbs')], SHBreadcrumbs);
export { SHBreadcrumbs };
